export const DEFAULT_HELP_EMAIL_SUBJECT_KEY = 'FOOTER.help_modal.default_subject'
